module.exports = __webpack_public_path__ + "static/media/foda.3c61df7a.mp3";